import {Link} from "react-router-dom";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactUnstablePage() {
    return (
        <ContactPageLayout
            meta_title={"Få fikset dit ustabile internet"}
            meta_description={"Bliv klogere på hvordan dit wifi fungerer og hvordan du kan optimere det. Download Hiper Guide app for at få indsigt omkring det."}
            title={"Ustabilt internet"}
            className={"page-contact-unstable"}
            content={
                <>
                    <section className="contact-content">
                        <p>Læs denne artikel for at se, hvad du kan gøre hvis dit internet er ustabilt.</p>
                        <Link
                            to={'/hjaelp/internet-og-wifi/ustabilt-internet'}
                            className={'button button--montserrat teal'}
                        >Ustabilt internet</Link>
                        <p>Vi anbefaler, at du læser denne artikel om, hvordan dit wifi fungerer og hvordan du kan optimere det.</p>
                        <Link
                            to={'/hjaelp/internet-og-wifi/forventninger-til-wifi'}
                            className={'button button--montserrat teal'}
                        >Hvad kan jeg forvente af mit wifi?</Link>
                    </section>

                    <ContactStillNeedHelpComponent phone={true}/>
                </>
            }
        />
    )
}
